export default __webpack_public_path__ + "static/media/img_placeholder_video.851c25da.png";